import { getDefaultStore, useAtomValue } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export interface DomainData {
  availableDomain: string;
  suggestions: string[];
}

const defaultDomainData: DomainData = {
  availableDomain: '',
  suggestions: [],
};

export const DomainDataAtom = atomWithReset<DomainData>(defaultDomainData);

export const useDomainData = () => {
  return useAtomValue(DomainDataAtom);
};

export const setDomainData = (partialData: Partial<DomainData>) => {
  const store = getDefaultStore();
  store.set(DomainDataAtom, (prev) => ({
    ...prev,
    ...partialData,
  }));
};

export const resetDomainData = () => {
  const store = getDefaultStore();
  store.set(DomainDataAtom, defaultDomainData);
};
